import { userLogout as logout } from "../services/auth";
import { logoutSegmentEvent } from "./segmentEventHandler";
import { getUserToken, removeAllLocalStorageData, removeUser } from "./user";

const checkAuth = () => {
  return getUserToken();
};

const setLoggedInUser = () => {};

const getLoggedInUser = () => {};

const userLogout = (navigate) => {
  const authToken = getUserToken();
  const channel = window.sessionStorage.getItem("channel");
  if (channel === "TOI") {
    navigate("/onboarding/signup", { replace: true });
    if (
      typeof window.webkit?.messageHandlers?.tilAppWebBridge !== "undefined"
    ) {
      window.webkit.messageHandlers.tilAppWebBridge.postMessage({
        requestReason: "fetchAppData",
        type: "abound",
        value: JSON.stringify({ token: "" }),
      });
    }
    if (typeof window.tilAppWebBridge !== "undefined") {
      window.tilAppWebBridge.postMessage(
        JSON.stringify({
          requestReason: "aboundLogin",
          type: "abound",
          value: JSON.stringify({ token: "" }),
        })
      );
    }
    logout(authToken);
    return;
  }
  logout(authToken)
    .then((response) => {
      removeUser()
        .then((response) => {
          removeAllLocalStorageData();
          logoutSegmentEvent();
          if (navigate) {
            navigate("/login?type=mobile");

            return;
          }
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    })
    .catch((error) => {});
};

export { checkAuth, setLoggedInUser, getLoggedInUser, userLogout };
